import React from 'react';
import ListActions from './ListActions'
import {
	List,
	Responsive,
	SimpleList,
	Datagrid,
	TextField,
	NumberField,
	DateField,
	RichTextField,
	FunctionField,
} from 'admin-on-rest'
import Badge from 'material-ui/Badge'
import Chip from 'material-ui/Chip'
import { DocumentationPerformanceFilters } from './Filters'

const top5DocDef = ({ top_5_doc_def_ }) => {
	if ( ! top_5_doc_def_ ) {
		return null;
	}
	const docDefs = JSON.parse( top_5_doc_def_ )
	return (
		<div style={{ paddingTop: '.5em', paddingBottom: '.5em' }}>
			{Object.keys( docDefs ).map( docName => (
				<Chip style={{ margin: 3 }}>
			      {docName} &middot; {docDefs[ docName ]}
			    </Chip>)
			)}
		</div>
	)
}

export const DocumentationPerformance = (props) => (
    <List {...props}
		title="Documentation Performance Report"
		filters={<DocumentationPerformanceFilters />}
		actions={<ListActions refreshInterval="900000" />}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.cs_num}
            //     />
            // }
            large={
				<Datagrid>
					<TextField source="label" label="Month" sortable={false} />
					<NumberField source="total_releases" label="Total Releases" sortable={false} />
					<NumberField source="avg_transmittal_days" label="Avg Transmittal Days" sortable={false} />
					<NumberField source="num_accounts_delayed_1_25" label="No. Accounts Delayed (1-25)" sortable={false} />
					<NumberField source="num_accounts_delayed_26_31" label="No. Accounts Delayed (26-31)" sortable={false} />
					<NumberField source="doc_def_rate" label="Current Doc Def Rate" options={{ maximumFractionDigits: 2, style: 'percent' }} sortable={false} />
					<NumberField source="max_doc_def_rate" label="Max Doc Def Rate" options={{ maximumFractionDigits: 2, style: 'percent' }} sortable={false} />
					<FunctionField source="top_5_doc_def_" label="Top 5 Doc Def" render={top5DocDef} sortable={false} />
		        </Datagrid>
            }
        />
    </List>
)



// WEBPACK FOOTER //
// ./src/reports/DocumentationPerformance.js